import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Heading from '@amzn/meridian/heading';
import Box from '@amzn/meridian/box';
import { FormattedMessage } from 'react-intl';

const GrowModelTypeDetermination: React.FC = (): React.ReactElement => {
  return (
    <Row type='outline' spacingInset='500 400'>
      <Column alignmentVertical='top'>
        <Text type='d50'>01</Text>
      </Column>
      <Box>
        <Column>
          <Heading level={4}>
            <FormattedMessage
              id='cs_perfportal_coaching_form_grow_model_determine_coaching_conversation'
              defaultMessage='Determine the type of coaching conversation you are having'
            />
          </Heading>
          <Row
            height='100%'
            width='100%'
            alignmentVertical='stretch'
            alignmentHorizontal='justify'
          >
            <Column
              width='100%'
              alignmentVertical='top'
              alignmentHorizontal='start'
              heights={['fit', 'fill']}
            >
              <Box height={32}>
                <Text type='h100'>
                  <FormattedMessage
                    id='cs_perfportal_coaching_form_grow_model_development_coaching'
                    defaultMessage='Development Coaching'
                  />
                </Text>
              </Box>
              <Box>
                <Text>
                  <FormattedMessage
                    id='cs_perfportal_coaching_form_grow_model_development_coaching_explanation'
                    defaultMessage='Helps the coachee identify a skill or behavior for which they have interest in improving.'
                  />
                </Text>
              </Box>
            </Column>
            <Column
              heights={['fit', 'fill']}
              width='100%'
              alignmentHorizontal='start'
              alignmentVertical='top'
            >
              <Box height={32}>
                <Text type='h100'>
                  <FormattedMessage
                    id='cs_perfportal_coaching_form_grow_model_career_growth_coaching'
                    defaultMessage='Career Growth Coaching'
                  />
                </Text>
              </Box>
              <Text>
                <FormattedMessage
                  id='cs_perfportal_coaching_form_grow_model_career_growth_coaching_explanation'
                  defaultMessage='Helps the coachee identify specific goals they can work on to attain a long-term career goal.'
                />
              </Text>
            </Column>
            <Column
              width='100%'
              alignmentHorizontal='start'
              alignmentVertical='top'
              heights={['fit', 'fill']}
            >
              <Box height={32}>
                <Text type='h100'>
                  <FormattedMessage
                    id='cs_perfportal_coaching_form_grow_model_performance_support_coaching'
                    defaultMessage='Performance Support Coaching'
                  />
                </Text>
              </Box>
              <Box>
                <Text>
                  <FormattedMessage
                    id='cs_perfportal_coaching_form_grow_model_performance_support_coaching_explanation'
                    defaultMessage='Helps the coachee improve upon a critical skill or behavior for which they are not meeting the performance bar.'
                  />
                </Text>
              </Box>
            </Column>
          </Row>
        </Column>
      </Box>
    </Row>
  );
};

export default GrowModelTypeDetermination;
